import React, { useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import { adSurfaceEnabled } from '../../config/ads';
import { adSlotVisible } from '../../utils/adsEnabled';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import { CardRoot, RowTop, AdTag, Sponsor, CardTitle, CardDesc, CtaRow } from './PromoAdCard.styled';

export default function PromoAdCard({ ad, pageKey, onImpression, onLinkClick }) {
  useEffect(() => {
    if (!onImpression || !ad?.managedCampaignId) return;
    onImpression();
  }, [onImpression, ad?.managedCampaignId]);

  if (!adSurfaceEnabled() || (pageKey && !adSlotVisible(pageKey)) || !ad) return null;

  const dest = isValidAdDestination(ad.url);
  const href = dest ? ad.url : '#';
  const onClick = (e) => {
    if (!dest) e.preventDefault();
    else onLinkClick?.(e);
  };

  return (
    <CardRoot
      href={href}
      onClick={onClick}
      target={dest ? '_blank' : undefined}
      rel={dest ? 'noopener noreferrer sponsored' : undefined}
    >
      <RowTop>
        <AdTag>Ad</AdTag>
        <Sponsor>{ad.sponsor}</Sponsor>
      </RowTop>
      <CardTitle>{ad.title}</CardTitle>
      <CardDesc>{ad.description}</CardDesc>
      <CtaRow>
        {ad.cta} <ExternalLink size={12} />
      </CtaRow>
    </CardRoot>
  );
}
